import React, { Component } from 'react';
import './webdev.css'
import Fade from 'react-reveal/Fade';

class WebDev extends Component {
    constructor(props) {
        super(props)
        this.state = {
            scrolling: false
        }
    }
    componentDidMount() {
        window.addEventListener('scroll', this.handleScroll);
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.handleScroll);
    }
    handleScroll = (event) => {
        console.log(window.innerWidth)
        if (window.innerWidth > 770) {
            if (window.scrollY > 400 && this.state.scrolling !== true) {
                this.setState({ scrolling: true });
            }
        }
        else if (window.innerWidth <= 770 && window.innerWidth > 690) {
            if (window.scrollY > 300 && this.state.scrolling !== true) {
                this.setState({ scrolling: true });
            }
        }

        else if (window.innerWidth <= 690 && window.innerWidth > 460) {
            if (window.scrollY > 200 && this.state.scrolling !== true) {
                this.setState({ scrolling: true });
            }
        }
        else if (window.innerWidth <= 460 && window.innerWidth >= 320) {
            if (window.scrollY > 100 && this.state.scrolling !== true) {
                this.setState({ scrolling: true });
            }
        }
        // window.innerHeight
        //   if (window.scrollY > 500 && this.state.scrolling !== true) {
        //         this.setState({ scrolling: true });
        //     }
    }
    render() {


        return (
            <div className='WebDevMainDiv'>

                <div className='WebDevMainDivChild1'>
                    <div>
                        {
                            this.state.scrolling ? (
                                <Fade top>

                                    <span className='WebDevHead1'>Web</span><span className='WebDevHead2'> Development</span>
                                </Fade>
                            ) : null
                        }
                        {
                            this.state.scrolling ? (
                                <Fade left>
                                    <p className='WebDevPara'>
                                        I design, build, operate & sometimes rescue web applications.
                                        If you have an application you are interested in developing with web technology, I’d love to work with you on it. I’m a Front-End-Engineer which means I can developed your project front end by using latest cutting edge front end technologies. I primarily work with React, Pure Javascript, Redux, Typescript, Html, Css/Sass, Bootstrap, Reactstrap, Firebase for the back-end.
                                        I enjoy each aspect, and love building web applications from start to finish, for clients all over the world.
                            </p>
                                </Fade>
                            ) : null
                        }

                    </div>
                    <div>
                        {
                            this.state.scrolling ? (
                                <Fade right>

                                    <img src={require('../../images/webicon.png')} />
                                </Fade>
                            ) : null
                        }
                    </div>
                </div>
            </div>
        );
    }
}

export default WebDev;



// WEBPACK FOOTER //
// ./src/containers/webdev/webdev.js